import { t } from 'i18next'

import type { HoldingDto } from '@hcr/api/consumer'
import type { BuildingDetailsDto } from '@hcr/api/optimizely'
import { UNICODE } from '@hcr/ui'

type CreateHoldingNameStringOptions = Pick<HoldingDto, 'room_number' | 'room_size'> &
  Partial<Pick<BuildingDetailsDto, 'destinationName'>>

export const createHoldingNameString = ({
  room_number,
  room_size,
  destinationName,
}: CreateHoldingNameStringOptions): string =>
  `${destinationName ? `${destinationName}, ` : ''}${t('utils.holding-apartment')} ${room_number}, ${room_size}m${UNICODE.superscriptTwo}`
